//@ts-nocheck
import axios from 'axios';
import {network, market} from 'src/constants/config';
import {Platform} from 'react-native';
import {store} from '../../store/index';
import DeviceInfo from '../../imports/DeviceInfo';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const createAxios = () => {
  const instance = axios.create({
    baseURL: network?.baseUrl,
    timeout: network.timeout,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      'Access-Control-Allow-Origin': '*',
      'Cache-Control': 'no-cache',
    },
  });
//   instance.interceptors.response.use(
//   async (response) => {
//     const { headers } = response;
//     if ('new-access-token' in headers) {
//       let Token=headers['new-access-token']
//         await AsyncStorage.setItem('token',Token );
//         dispatch(getUser({ token: newAccessToken }));
//       }
//     return response;
//   },
//   async (error) => {
//     if (error?.response?.status === 401 || error?.response?.status === 419) {
//             dispatch(
//               showAlert({
//                 id: 'AlertBox',
//                 modalProps: {
//                   icon: 'redExclamation',
//                   title: t('401'),
//                 },
//               }),
//             );
//             history.replace('/logout');
//           }
//     //eslint-disable-next-line
//     return Promise.reject(error);
//   }
// );
  instance.interceptors.request.use(async config => {
    let {token} = store.getState().user;
    if (!!token) config.headers.Authorization = `Bearer ${token}`;
    if (Platform.OS === 'android') {
      config.headers['User-Agent'] = DeviceInfo.getUserAgentSync();
      config.headers.AndroidId = await DeviceInfo.getAndroidId();
      if (__DEV__) {
        config.headers.Market = 'develop';
      } else {
        config.headers.Market = market;
      }
    } else {
      config.headers.Market = 'pwa';
    }
    return config;
  });
  const {request, response} = instance.interceptors;
  if (Platform.OS === 'android') {
    if (__DEV__) {
      // request.use(requestLogger, errorLogger);
      // response.use(responseLogger, errorLogger);
    }
  }
  
  return instance;
};
